import { z } from 'zod';

export const zodSignatureRequestSchema = z.object({
  createdAt: z.iso.datetime({ offset: true }),
  // deliveryNoteId/userEmail/userId/userName are optional per the API's
  // SignatureRequestRecipient schema (only created_at is required) - the API can omit
  // them entirely rather than sending null, e.g. for a recipient whose user record
  // has since been deleted.
  deliveryNoteId: z.uuid().nullish(),
  userEmail: z.string().nullish(),
  userId: z.uuid().nullish(),
  userName: z.string().nullish(),
});

export const zodSignatureRequestsResponseSchema = z.array(
  zodSignatureRequestSchema,
);

export const zodSignatureRequestsBulkResponseSchema = z.record(
  z.uuid(),
  z.array(zodSignatureRequestSchema),
);

export const zodCreateSignatureRequestsBodySchema = z.object({
  deliveryNoteIds: z.array(z.uuid()),
  recipientIds: z.array(z.uuid()),
});

export const zodCreateSignatureRequestsResponseSchema = z.object({
  code: z.number(),
  message: z.string(),
});

export const zodQuerySignatureRequestsBodySchema = z.object({
  deliveryNoteIds: z.array(z.uuid()).max(250).nullable().optional(),
});
